/* Shared instrument product rail runtime. */
(function () {
  var runtime = window.AbrsmInstrumentRails || {};

  if (typeof runtime.initWithin === 'function') {
    runtime.initWithin(document);
    return;
  }

  function init(root) {
    if (!root || root.dataset.abrsmInstrumentRailsReady === 'true') return;
    root.dataset.abrsmInstrumentRailsReady = 'true';

    var instrumentHandle = root.getAttribute('data-instrument-handle') || '';
    var templateName = root.getAttribute('data-template-name') || '';

    function emit(eventName, detail) {
      var payload = Object.assign({
        instrument_handle: instrumentHandle,
        template_name: templateName
      }, detail || {});

      document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }

    function normaliseQuantity(value) {
      var parsed = parseInt(value, 10);
      if (isNaN(parsed) || parsed < 1) return 1;
      return parsed;
    }

    function buildCartAddPayload(form) {
      var formData = new FormData(form);
      var items = [];

      formData.forEach(function (value, key) {
        var match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        if (!match) return;

        var index = parseInt(match[1], 10);
        items[index] = items[index] || {};
        items[index][match[2]] = value;
      });

      items = items.filter(function (item) {
        return item && item.id;
      }).map(function (item) {
        return {
          id: parseInt(item.id, 10),
          quantity: normaliseQuantity(item.quantity)
        };
      }).filter(function (item) {
        return item.id > 0;
      });

      if (items.length) {
        return { items: items };
      }

      return {
        id: parseInt(formData.get('id') || '', 10),
        quantity: normaliseQuantity(formData.get('quantity'))
      };
    }

    function dispatchAjaxProductAdded(sourceNode, submitBtn, product) {
      sourceNode.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: product,
          addToCartBtn: submitBtn
        },
        bubbles: true
      }));
    }

    function bindAddForm(form, detailFactory) {
      if (!form || form.dataset.abrsmAddBound === 'true') return;
      form.dataset.abrsmAddBound = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (form.dataset.abrsmSubmitting === 'true') return;

        emit('abrsm:instrument_quick_add', detailFactory(form));

        var payload = buildCartAddPayload(form);
        if ((!payload.id || payload.id < 1) && (!payload.items || !payload.items.length)) return;

        var submitBtn = form.querySelector('button[type="submit"]');
        var originalLabel = submitBtn ? submitBtn.textContent : '';
        var added = false;

        form.dataset.abrsmSubmitting = 'true';

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.add('is-loading');
        }

        fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return {
                ok: response.ok,
                data: data
              };
            });
          })
          .then(function (result) {
            if (!result.ok || (result.data && result.data.status === 422)) {
              throw new Error((result.data && result.data.description) || 'Unable to add item to cart.');
            }

            added = true;
            if (submitBtn) {
              submitBtn.textContent = 'Added!';
            }

            dispatchAjaxProductAdded(form, submitBtn, result.data);
          })
          .catch(function (error) {
            console.warn('Instrument rail add to cart failed.', error);
          })
          .finally(function () {
            form.dataset.abrsmSubmitting = 'false';

            if (!submitBtn) return;

            var resetButton = function () {
              submitBtn.disabled = false;
              submitBtn.classList.remove('is-loading');
              submitBtn.textContent = originalLabel;
            };

            if (added) {
              window.setTimeout(resetButton, 900);
            } else {
              resetButton();
            }
          });
      });
    }

    var railUpdaters = [];

    function refreshRails() {
      railUpdaters.forEach(function (fn) { fn(); });
    }

    function bindPanel(panel) {
      if (!panel || panel.dataset.abrsmRailPanelBound === 'true') return;
      panel.dataset.abrsmRailPanelBound = 'true';

      panel.querySelectorAll('[data-abrsm-product-link]').forEach(function (node) {
        node.addEventListener('click', function () {
          emit('abrsm:instrument_product_click', {
            module: node.getAttribute('data-module') || 'rail',
            position: Number(node.getAttribute('data-position') || 0),
            product_handle: node.getAttribute('data-product-handle') || ''
          });
        });
      });

      panel.querySelectorAll('[data-abrsm-quick-add]').forEach(function (form) {
        bindAddForm(form, function (currentForm) {
          return {
            module: currentForm.getAttribute('data-module') || 'rail',
            position: Number(currentForm.getAttribute('data-position') || 0),
            product_handle: currentForm.getAttribute('data-product-handle') || ''
          };
        });
      });

      panel.querySelectorAll('[data-abrsm-add-all]').forEach(function (form) {
        bindAddForm(form, function (currentForm) {
          return {
            module: currentForm.getAttribute('data-module') || 'rail-add-all',
            position: Number(currentForm.getAttribute('data-position') || 0),
            product_handle: 'multiple'
          };
        });
      });

      panel.querySelectorAll('[data-rail]').forEach(function (rail) {
        if (rail.dataset.abrsmRailBound === 'true') return;
        rail.dataset.abrsmRailBound = 'true';

        var track = rail.querySelector('[data-rail-track]');
        var prev = rail.querySelector('[data-rail-prev]');
        var next = rail.querySelector('[data-rail-next]');
        if (!track || !prev || !next) return;

        function scrollByPage(direction) {
          var amount = Math.max(track.clientWidth * 0.92, 260);
          track.scrollBy({ left: amount * direction, behavior: 'smooth' });
        }

        function updateNavState() {
          var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          var canScroll = maxScroll > 4;
          prev.disabled = !canScroll || track.scrollLeft <= 2;
          next.disabled = !canScroll || track.scrollLeft >= (maxScroll - 2);
        }

        prev.addEventListener('click', function () {
          scrollByPage(-1);
        });

        next.addEventListener('click', function () {
          scrollByPage(1);
        });

        track.addEventListener('scroll', updateNavState, { passive: true });
        railUpdaters.push(updateNavState);
        updateNavState();
      });
    }

    function hydratePanel(panel) {
      if (!panel) return false;
      if (panel.dataset.gradePanelHydrated === 'true') {
        bindPanel(panel);
        return true;
      }

      var template = panel.querySelector('[data-grade-panel-template]');
      if (!template) return false;

      panel.appendChild(template.content.cloneNode(true));
      template.remove();
      panel.dataset.gradePanelHydrated = 'true';
      bindPanel(panel);
      return true;
    }

    function panelHasRail(panel) {
      if (!panel) return false;
      if (panel.querySelector('[data-rail]')) return true;

      var template = panel.querySelector('[data-grade-panel-template]');
      return Boolean(template && template.content.querySelector('[data-rail]'));
    }

    var gradeTabs = Array.prototype.slice.call(root.querySelectorAll('[data-grade-tab]'));
    var gradePanels = Array.prototype.slice.call(root.querySelectorAll('[data-grade-panel]'));

    function setActiveGrade(targetPanelId) {
      var targetPanel = gradePanels.find(function (panel) {
        return panel.getAttribute('data-grade-panel') === targetPanelId;
      });
      if (!panelHasRail(targetPanel)) return false;
      if (!hydratePanel(targetPanel)) return;

      gradeTabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-grade-tab') === targetPanelId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      gradePanels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-grade-panel') === targetPanelId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(refreshRails);
      });

      return true;
    }

    gradePanels.forEach(function (panel) {
      if (panel.dataset.gradePanelHydrated === 'true') bindPanel(panel);
    });

    if (gradeTabs.length > 0 && gradePanels.length > 0) {
      gradeTabs.forEach(function (tab) {
        tab.addEventListener('click', function (event) {
          var targetPanelId = tab.getAttribute('data-grade-tab');
          var targetPanel = gradePanels.find(function (panel) {
            return panel.getAttribute('data-grade-panel') === targetPanelId;
          });
          var detail = {
            module: 'grade-filter',
            position: Number(tab.getAttribute('data-position') || 0)
          };

          if (tab.tagName === 'A' && tab.href && !panelHasRail(targetPanel)) {
            emit('abrsm:instrument_cta_click', detail);
            return;
          }

          event.preventDefault();
          if (!setActiveGrade(targetPanelId)) return;
          emit('abrsm:instrument_cta_click', {
            module: detail.module,
            position: detail.position
          });
        });
      });

      var gradeTabsContainer = root.querySelector('[role="tablist"]');
      if (gradeTabsContainer) {
        gradeTabsContainer.addEventListener('keydown', function (e) {
          var currentIndex = gradeTabs.indexOf(document.activeElement);
          if (currentIndex === -1) return;
          var newIndex = -1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            newIndex = (currentIndex + 1) % gradeTabs.length;
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            newIndex = (currentIndex - 1 + gradeTabs.length) % gradeTabs.length;
          } else if (e.key === 'Home') {
            e.preventDefault();
            newIndex = 0;
          } else if (e.key === 'End') {
            e.preventDefault();
            newIndex = gradeTabs.length - 1;
          }
          if (newIndex !== -1) {
            gradeTabs[newIndex].focus();
            gradeTabs[newIndex].click();
          }
        });
      }
    }

    window.addEventListener('resize', function () {
      window.requestAnimationFrame(refreshRails);
    });

    refreshRails();
  }

  function initWithin(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('[data-abrsm-instrument-rails]')) init(scope);
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll('[data-abrsm-instrument-rails]').forEach(init);
  }

  runtime.initWithin = initWithin;
  window.AbrsmInstrumentRails = runtime;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initWithin(document); }, { once: true });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });
})();
